import { Navigate } from 'react-router-dom';
import { useAppStore } from '../../stores/appStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAppStore((state) => state.isAuthenticated);
  const currentUser = useAppStore((state) => state.currentUser);

  if (!isAuthenticated) {
    // Redirect to login page if not authenticated
    return <Navigate to="/login" replace />;
  }

  // Check if user has Pending role - show access pending message
  if (currentUser?.role === 'Pending') {
    return <PendingApproval />;
  }

  return <>{children}</>;
}

function PendingApproval() {
  const logout = useAppStore((state) => state.logout);
  const currentUser = useAppStore((state) => state.currentUser);

  return (
    <div className="min-h-screen bg-gradient-to-br from-secondary-50 via-white to-primary-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h2 className="text-xl font-bold text-neutral-900 mb-2">
            Access Pending
          </h2>

          <p className="text-neutral-600 mb-4">
            Hello <span className="font-medium">{currentUser?.name}</span>,
          </p>

          <p className="text-neutral-600 mb-6">
            Your account has been created successfully but requires administrator approval before you can access the platform.
            Please contact your administrator to enable access.
          </p>

          <div className="bg-neutral-50 rounded-lg p-4 mb-6 text-left">
            <p className="text-sm text-neutral-500 mb-1">Your email</p>
            <p className="text-sm font-medium text-neutral-900">{currentUser?.email}</p>
          </div>

          <button
            onClick={logout}
            className="w-full px-4 py-2 bg-neutral-100 text-neutral-700 rounded-lg hover:bg-neutral-200 transition-colors font-medium"
          >
            Sign Out
          </button>
        </div>

        <p className="mt-6 text-sm text-neutral-500">
          &copy; 2024 Amplinth. All rights reserved.
        </p>
      </div>
    </div>
  );
}
